import React, { useState, useEffect, useCallback } from 'react';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { CancelButton } from 'uiwidgets/CancelButton';
import { Row, Col, Card, Table, Button, Modal } from 'react-bootstrap';
import { API } from '../../api/API';
import { BUSINESS_DONATION_BOXES_URL, USER_EMAIL_ADDRESS_EXISTS, BUSINESS_DONATION_CAUSES,
    PAYMENTINTENT_TOKEN_URL } from 'config/config';
import { extractError } from '../../api/ErrorUtil';
import { v4 as uuidv4 } from 'uuid';

import {
    isFullFormValid, containsAlphaNumAndSpaceAndPunctuationOnly
} from 'util/Validators';
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faDollar, faArrowLeft, faArrowRight, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { PAGE_SIZE } from 'config/config';
import { isEmailAddressValid } from 'util/Validators';
import { isNumeric } from 'util/Validators';
import { evenRound } from 'util/NumberUtils';

const BusinessDonationBoxes = () => {
    const initialState = {
        donationBoxId: "",
        errors: {},
        infoMessage: "",
        boxSerialNumber: "",
        donorEmail: "",
        readOnly: false,
        editMode: false,
        keyword: ""
    }

    const initialValidationState = {
        boxSerialNumberError: false,
        boxSerialNumberErrMsg: "",
        donorEmailError: false,
        donorEmailErrMsg: "",
        keywordError: false,
        keywordErrMsg: "",
    }

    const initialBoxSubmissionState = {
        donationAmount: "",
        makeReceiptInCompanyName: "",
        errors: {},
        infoMessage: "",
        readOnly: false,

    }

    const initialBoxSubmissionValidationState = {
        donationAmountErrMsg: "",
        makeReceiptInCompanyNameErrMsg: "",
        donationAmountError: false,
        makeReceiptInCompanyNameError: false
    }

    let [formData, setFormData] = useState(initialState);
    let [formValidityData, setFormValidityData] = useState(initialValidationState);
    let [donationBoxes, setDonationBoxes] = useState([]);
    let [currentPage, setCurrentPage] = useState(0)
    let [totalNumberOfPages, setTotalNumberOfPages] = useState(0);

    let [donationBoxCause, setDonationBoxCause] = useState({});
    let [boxSubmissionData, setBoxSubmissionData] = useState(initialBoxSubmissionState);
    let [boxSubmissionValidationData, setBoxSubmissionValidationData] = useState(initialBoxSubmissionValidationState);

    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }

    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const onDonationBoxToastClose = () => {
        setBoxSubmissionData({
            ...boxSubmissionData,
            ...messageReset()
        });
    }

    const [showDonateBoxFunds, setshowDonateBoxFunds] = useState({ show: false, donationBox: {}, user: {} });
    const handleDonateBoxFundsClose = () => {
        setshowDonateBoxFunds({ show: false, donationBox: {}, user: {} });
        setBoxSubmissionData(initialBoxSubmissionState);
        setBoxSubmissionValidationData(initialBoxSubmissionValidationState);
    }
    const handleDonateBoxFundsShow = async (event, donationBox) => {
        //fetch the user
        try {
            let emailExistsUrl = USER_EMAIL_ADDRESS_EXISTS.replace('${userEmailAddress}', donationBox.donorEmail);
            let response = await API.get(emailExistsUrl);
            setshowDonateBoxFunds({ show: true, donationBox: donationBox, user: response.data });
        } catch (err) {
            let exError = extractError(err);
            setBoxSubmissionData({
                ...boxSubmissionData,
                errors: exError
            })
        }
    }

    const fetchDonationCauses = useCallback(async () => {
        try {
            let donationCauseUrl = BUSINESS_DONATION_CAUSES + "?nonactive=true";
            let donationCausesResponse = await API.get(donationCauseUrl)
            let donationCauses = donationCausesResponse.data;
            let selectedCause = donationCauses.find(dc => dc.donationCauseCode === 'DONATIONBOX');
            if (!_.isEmpty(selectedCause)) {
                setDonationBoxCause(selectedCause);
            }
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError
            })
        }
    })

    const fetchDonationBoxesForce = useCallback(async () => {
        try {
            let donationBoxesResp = await API.get(BUSINESS_DONATION_BOXES_URL, {
                params: {
                    page: 0,
                    size: PAGE_SIZE,
                    keyword: "",
                }
            });
            setDonationBoxes(donationBoxesResp.data.content);
            setTotalNumberOfPages(donationBoxesResp.data.totalPages);
            setCurrentPage(0);
            setFormData({
                ...formData,
                keyword: ""
            })
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setDonationBoxes([]);
                setFormData({ ...formData, infoMessage: "No donation boxes were found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }

    })

    const fetchDonationBoxes = useCallback(async () => {
        try {
            let donationBoxesResp = await API.get(BUSINESS_DONATION_BOXES_URL, {
                params: {
                    page: currentPage, size: PAGE_SIZE,
                    keyword: formData.keyword ? formData.keyword.trim() : "",
                }
            });
            setDonationBoxes(donationBoxesResp.data.content);
            setTotalNumberOfPages(donationBoxesResp.data.totalPages);
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setDonationBoxes([]);
                setFormData({ ...formData, infoMessage: "No donation boxes were found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }

    })

    useEffect(() => {
        fetchDonationBoxes();
        fetchDonationCauses();
    }, []);

    useEffect(() => {
        fetchDonationBoxes();
    }, [currentPage]);

    useEffect(() => {
        if (formData.keyword && formData.keyword.length > 3) {
            fetchDonationBoxes();
        }
    }, [formData.keyword]);


    const handleChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const editDonationBox = async (event, donationBox) => {
        setFormData({
            ...donationBox,
            editMode: true
        });
        setFormValidityData(initialValidationState)
    }

    const deleteDonationBox = async (event, donationBox) => {
        try {
            await API.delete(BUSINESS_DONATION_BOXES_URL + "/" + donationBox.id);
            setFormData({
                initialState,
                infoMessage: "Donation Box type was deleted successfully"
            });

        } catch (error) {
            let exError = extractError(error);
            setFormData({
                initialState,
                errors: exError
            })
        }
        fetchDonationBoxes();
    }

    const handleCancel = async (event) => {
        setFormData(initialState);
        setFormValidityData(initialValidationState)
    }

    const validateInput = (name, value) => {
        let hasError = false, error = "";
        switch (name) {
            case "keyword":
                if (!value || (value && value.trim()) === "") {
                    hasError = false
                    error = ""
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Invalid keyword. Only alphanumeric characters are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "boxSerialNumber":
                if (!value || (value && value.trim()) === "") {
                    hasError = true
                    error = "Box Serial Number is required";
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Invalid box serial number. Only alphanumeric characters are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "donorEmail":
                if (!value || (value && value.trim()) === "") {
                    hasError = true
                    error = "Donor Email is required";
                } else if (!isEmailAddressValid(value)) {
                    hasError = true
                    error = "Invalid email address.";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "donationAmount":
                if (!value || value.trim() === "") {
                    hasError = true
                    error = "Donation Amount is required"
                } else if (!isNumeric(value)) {
                    hasError = true
                    error = "Donation Amount is invalid"
                } else {
                    hasError = false
                    error = ""
                }
                break
            default:
                break;
        }

        return { hasError, error };
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        let formValid = isFullFormValid(formValidityData)

        if (!formValid) {
            alert("Form has validation errors");
            return false;
        }
        try {

            if (formData.editMode) {
                console.log("Updating Donation Box", formData);
                let updateResp = await API.put(BUSINESS_DONATION_BOXES_URL + "/" + formData.id, {
                    boxSerialNumber: formData.boxSerialNumber,
                    donorEmail: formData.donorEmail
                });
            } else {
                console.log("Add new Donation Box");
                let newResp = await API.post(BUSINESS_DONATION_BOXES_URL, {
                    boxSerialNumber: formData.boxSerialNumber,
                    donorEmail: formData.donorEmail,
                });
            }
            setFormData({
                initialState,
                infoMessage: "Donation box was saved successfully"
            });
            fetchDonationBoxes();

        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError

            })
        }
        
    }

    const handleFilterKeyDown = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            fetchDonationBoxes();
        }
    };
    const clearFilter = async (event) => {
        fetchDonationBoxesForce();
    };

    const handlePaging = async (page) => {
        if (page < 0) {
            alert("Reached the beginning of data set")
            page = 0;
        }
        if (page > totalNumberOfPages - 1) {
            alert("Reached the end of data set")
            page = totalNumberOfPages - 1;
        }
        setCurrentPage(page);
    }

    const handleBoxSubmissionChange = async (event) => {
        if (boxSubmissionData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setBoxSubmissionData({
            ...boxSubmissionData,
            [name]: value
        })
    }

    const handleBoxSubmissionValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setBoxSubmissionValidationData({
            ...boxSubmissionValidationData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const donateBoxFunds = async (event, user) => {
        event.preventDefault();
        let {hasError,error} = validateInput("donationAmount",boxSubmissionData.donationAmount);
        if (hasError){
            setBoxSubmissionValidationData({
                ...boxSubmissionValidationData,
                donationAmountError: hasError,
                donationAmountErrMsg: error
            }) 
            return false; 
        }
        
        if (!donationBoxCause){
            setBoxSubmissionData({
                ...boxSubmissionData,
                errors: {message: "Donation Cause Id could not be determined"}
            })
            return false;
        }
        let paymentRequest = {
            payer: {
                ...user
            },
            commitmentItems: [
                {
                    commitmentId: uuidv4(),
                    commitmentType: "DONATION",
                    commitmentPaymentAmount: parseFloat(evenRound(boxSubmissionData.donationAmount,2))*100,
                    paymentItems: [
                        {
                            causeId: donationBoxCause.id,
                            causeCode: donationBoxCause.donationCauseCode,
                            lineItemAmount: parseFloat(evenRound(boxSubmissionData.donationAmount,2))*100,
                            lineItemDescription: "Donation Box",
                            donationCauseAttributes: [],
                            sponsorshipCause: false,
                            quantity: 1
                        }
                    ]
                }
            ],
            customerConsentsToPayPfFees: false,
            paymentSourceType: "OFFLINE",
            paymentCorrespodence: "",
            receiptInCompanyName: boxSubmissionData.makeReceiptInCompanyName,
        }

        try {
            let paymentResp = await API.post(PAYMENTINTENT_TOKEN_URL, paymentRequest);
            setBoxSubmissionData({
                ...boxSubmissionData,
                infoMessage: (paymentResp.data.message?+paymentResp.data.message:"")+ " Payment Successful. Transaction Number:"+paymentResp.data.transactionNumber,
                readOnly: true
            })
            

        } catch (error) {
            let errors = extractError(error);
            setBoxSubmissionData({
                ...boxSubmissionData,
                errors: errors
            })
        }

    }

    return (
        <>
            <FormContainer title="Donation Boxes" submitButtonFunction={handleSubmit}
                errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
                <Row><Col>Enter a box serial number to associate with the donor's email address. Please note that the email address must correspond to a user already in the system. 
                If this user does not exist, please create an account bearing this email address.</Col></Row>    
                <Row>
                    <Col mb={4} lg={4} sm={12}>
                        <FormField name="boxSerialNumber" label="Box Serial Number" type="text" value={formData.boxSerialNumber}
                            placeholder="Enter Box Serial Number" onChange={handleChange} onBlur={handleValidation}
                            valstate={!formValidityData.boxSerialNumberError} valMsg={formValidityData.boxSerialNumberErrMsg}
                            readOnly={formData.readOnly} />
                    </Col>
                    <Col mb={4} lg={4} sm={12}>
                        <FormField name="donorEmail" label="Associated Email address" type="text" value={formData.donorEmail}
                            placeholder="Associated Email Address"
                            onChange={handleChange} onBlur={handleValidation}
                            valstate={!formValidityData.donorEmailError} valMsg={formValidityData.donorEmailErrMsg}
                            readOnly={formData.editMode} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SubmitButton label='Save Donation Box Assignment' disabled={formData.readOnly} className="me-4" />
                        <CancelButton label='Cancel' onClick={handleCancel} />
                    </Col>
                </Row>
                <Row><Col>&nbsp;</Col></Row>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col sm={12} md={6} lg={6}>
                                <FormField name="keyword" label="Serial Number or Email" type="text" value={formData.keyword}
                                    placeholder="Serial Number or Email" onChange={handleChange}
                                    onBlur={handleValidation} onKeyDown={handleFilterKeyDown}
                                    valstate={!formValidityData.keywordError} valMsg={formValidityData.keywordErrMsg} />
                            </Col>
                            <Col sm={6} md={2} lg={2}>
                                <br />
                                <Button variant="info" className="border-0 btn-fill" onClick={clearFilter}><strong><small>Clear Filter</small></strong></Button>
                            </Col>
                            {!_.isEmpty(donationBoxes) &&
                                <React.Fragment>
                                    <Col className='d-flex justify-content-end'>
                                        <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage - 1) }}>
                                            <h6><FontAwesomeIcon icon={faArrowLeft} />Previous Page</h6>
                                        </Button>
                                        &nbsp;<span className="border-0 text-dark btn"><br /><h6>{currentPage + 1} of {totalNumberOfPages}</h6></span>
                                        &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage + 1) }}>
                                            <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
                                        </Button>
                                    </Col>
                                </React.Fragment>}
                        </Row>
                        <Table className="table-hover table-striped">
                            <thead>
                                <tr>
                                    <th className="border-0">Serial Number</th>
                                    <th className="border-0">Associated Email Address</th>
                                    <th className="border-0">Edit</th>
                                    <th className="border-0">Delete</th>
                                    <th className="border-0">Donate Box Funds</th>
                                </tr>

                            </thead>
                            <tbody>
                                {donationBoxes && !_.isEmpty(donationBoxes) && donationBoxes.map((donationBox, idx) => (
                                    <tr key={idx}>
                                        <td>{donationBox.boxSerialNumber}</td>
                                        <td>{donationBox.donorEmail}</td>
                                        <td>
                                            <Button variant="dark" className="border-0 text-dark" onClick={evt => editDonationBox(evt, donationBox)}>
                                                <FontAwesomeIcon icon={faEdit} />
                                            </Button>
                                        </td>
                                        <td>
                                            <Button variant="dark" className="border-0 text-dark" onClick={evt => deleteDonationBox(evt, donationBox)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </Button>
                                        </td>
                                        <td>
                                            <Button variant="dark" className="border-0 text-dark" onClick={event => handleDonateBoxFundsShow(event, donationBox)}>
                                                <FontAwesomeIcon icon={faDollar} title="Donate Box Funds" />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </FormContainer>
            <Modal show={showDonateBoxFunds.show} onHide={handleDonateBoxFundsClose}>
                <Modal.Header closeButton><b>Donate Box Funds</b></Modal.Header>
                <Modal.Body>
                    <FormContainer title="" toastCloseFunc={onDonationBoxToastClose} errors={boxSubmissionData.errors} infoMessage={boxSubmissionData.infoMessage} 
                        submitButtonFunction={event => donateBoxFunds(event, showDonateBoxFunds.user)}>

                        Donation on behalf of: <b>{showDonateBoxFunds.user.firstName} {showDonateBoxFunds.user.lastName}</b> <br/>
                        Company Name: <b>{showDonateBoxFunds.user.companyName ? showDonateBoxFunds.user.companyName : "Not Provided"}</b><br/> 
                        of <b>{showDonateBoxFunds.user.address}, {showDonateBoxFunds.user.city},{showDonateBoxFunds.user.state}, {showDonateBoxFunds.user.zip}</b><br/>
                        with email of <b>{showDonateBoxFunds.user.email}</b>
                           
                        <FormField name="donationAmount" label="Donation Box Amount" type="text" value={boxSubmissionData.donationAmount}
                            placeholder="Donation Box Amount" onChange={handleBoxSubmissionChange} onBlur={handleBoxSubmissionValidation}
                            valstate={!boxSubmissionValidationData.donationAmountError} valMsg={boxSubmissionValidationData.donationAmountErrMsg}
                            readOnly={boxSubmissionData.readOnly} />

                        <Table><tbody>
                            <tr><td className="mt-4 p-0" style={{ borderStyle: 'none' }} colSpan="2">
                                If you would like to have the receipt for the recurring payments in the name of your organization,
                                update the "Company Name" field for the user account and select this checkbox.
                            </td></tr>
                            <tr>
                                <td className="m-0 p-0" style={{ borderStyle: 'none' }} width="35px">
                                    <br /><FormField
                                        name="makeReceiptInCompanyName"
                                        type="checkbox"
                                        checktype="checkbox"
                                        disabled={boxSubmissionData.readOnly || _.isEmpty(showDonateBoxFunds.user.companyName)}
                                        value={boxSubmissionData.makeReceiptInCompanyName}
                                        checked={boxSubmissionData.makeReceiptInCompanyName}
                                        onChange={handleBoxSubmissionChange}
                                        onBlur={handleBoxSubmissionValidation}
                                        valstate={!boxSubmissionValidationData.makeReceiptInCompanyNameError}
                                        valMsg={boxSubmissionValidationData.makeReceiptInCompanyNameErrMsg} />
                                </td>
                                <td className="m-0 p-0" style={{ borderStyle: 'none' }}>
                                    <br /><label><nobr>Receipt In Company Name <FontAwesomeIcon icon={faInfoCircle} title="may be disabled due to absence of Company Name in user profile" /></nobr></label>
                                </td>
                            </tr>
                        </tbody>
                        </Table>

                        <br />
                        <SubmitButton label="Donate Box Funds" disabled={boxSubmissionData.readOnly}/>
                    </FormContainer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default BusinessDonationBoxes